import { render, staticRenderFns } from "./ProtagonistsCarousel.vue?vue&type=template&id=1f5ddbf1"
import script from "./ProtagonistsCarousel.vue?vue&type=script&lang=js"
export * from "./ProtagonistsCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports